export default __webpack_public_path__ + "23f82beea1a995805e883677b2ded665.png";